/**
 * theme for MUI
 * TODO: create a theme object as per designs
 */
import { ptBR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { shade } from 'polished';
import type {} from '@mui/lab/themeAugmentation';
import type {} from '@mui/x-data-grid/themeAugmentation';

export const title = process.env.REACT_APP_TITLE || 'Jump Tecnologia';

export const logoUrl = process.env.REACT_APP_LOGO_URL || '';

export const theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: process.env.REACT_APP_PRIMARY_COLOR || '#1E5168',
        contrastText: '#fff',
      },
      secondary: {
        main: process.env.REACT_APP_SECONDARY_COLOR || '#13BC4B',
        contrastText: '#fff',
      },
      error: {
        main: '#e62929',
        contrastText: '#fff',
      },
      success: {
        main: '#50eb6f',
        contrastText: '#fff',
      },
      warning: {
        main: '#e8d22e',
        contrastText: '#fff',
      },
      divider: '#e0e0e0',
      text: {
        main: '#666666',
        contrastText: '#fff',
      },
      background: {
        main: '#F3F3F3',
        contrastText: '#000',
      },
      action: {
        disabledBackground: shade(
          0.2,
          process.env.REACT_APP_DISABLED_BACKGROUND_COLOR || '#0069a6',
        ),
        // disabled: 'set color of text here'
      },
    },
    components: {
      MuiTypography: {
        defaultProps: {
          variantMapping: {
            h1: 'h2',
            h2: 'h2',
            h3: 'h2',
            h4: 'h2',
            h5: 'h2',
            h6: 'h2',
            subtitle1: 'h2',
            subtitle2: 'h2',
            body1: 'span',
            body2: 'span',
          },
        },
      },
    },
    typography: {
      button: {
        textTransform: 'none',
        // Using this will stop tranforming all button texts to UPPERCASE
      },
    },
  },
  ptBR,
);
